module.exports = __webpack_public_path__ + "static/32DCAF_2_0-9d5e9b393423e7f97854e42be188aac1.woff";